
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col">
          Any unsaved changes will be lost without saving.<br/>
          Are you sure you want to continue?
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="onOk()" class="btn btn-sm btn-danger">Go Away</button>
    <button type="button" (click)="onCancel()" class="btn btn-sm btn-success">Return</button>
  </div>
